<template>
  <extra-opmerkingen/>
</template>

<script>
import ExtraOpmerkingen from '../components/OpbouwPlechtigheid/ExtraOpmerkingen.vue'

export default {
  name: 'ExtraOpmerkingenView',
  components: {
    ExtraOpmerkingen
  }
}
</script>
